/**
 * Loads google source services
 */
export default class Loader
{
	static #isGoogleApiLoaded = false;

	static #createSrc(apiKey, languageId)
	{
		return 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places&language=' + languageId;
	}

	/**
	 * Loads google services
	 * @param {string} apiKey
	 * @param {string} languageId
	 * @returns {Promise}
	 */
	static load(apiKey: string, languageId: string): Promise
	{
		return new Promise((resolve) => {

			if(Loader.#isGoogleApiLoaded)
			{
				resolve();
			}

			BX.load(
				[Loader.#createSrc(apiKey, languageId)],
				() => {
					Loader.#isGoogleApiLoaded = true;
					resolve();
				}
			);
		});
	}
}